// import 'datatables.net-bs4';
import { MdColors } from './configs';

export function getMdColors(startIdx) {
  if (startIdx === 0) {
    return MdColors;
  }
  const part1 = [];
  const part2 = [];
  let i = 0;
  MdColors.forEach((color) => {
  // eslint-disable-next-line no-unused-expressions
    i <= startIdx ? part1.push(color) : part2.push(color);
    i += 1;
  });
  return part1.concat(part2);
}

const pluginsIntegrated = [];
export function integratePlugin(Ctor, optionsProp, domLetter) {
  // Prevent re-integrating
  if (pluginsIntegrated.includes(domLetter)) {
    return;
  }
  $.fn.dataTable.ext.feature.push({
    fnInit(settings) {
      const dataTablesApi = new $.fn.dataTable.Api(settings);
      const initOptions = dataTablesApi.init();
      const pluginOptions = initOptions[optionsProp];
      return new Ctor(settings, pluginOptions).node();
    },
    cFeature: domLetter,
  });
}

export function enablePipeline() {
  // Prevent re-registering
  if (typeof $.fn.dataTable.pipeline === 'function') {
    return;
  }
  // Pipelining function for DataTables. To be used to the `ajax` option of DataTables
  $.fn.dataTable.pipeline = (opts) => {
    // Configuration options
    const conf = $.extend({
      pages: 5, // number of pages to cache
      url: '', // script url
      // function or object with parameters to send to the server
      // matching how `ajax.data` works in DataTables
      data: null,
      method: 'GET', // Ajax HTTP method,
      cache: true,
    }, opts);

    // Private variables for storing the cache
    let cacheLower = -1;
    let cacheUpper = null;
    let cacheLastRequest = null;
    let cacheLastJson = null;

    return (request, drawCallback, settings) => {
      let ajax = false;
      let requestStart = request.start;
      const drawStart = request.start;
      const requestLength = request.length;
      const requestEnd = requestStart + requestLength;

      if (settings.clearCache) {
        // API requested that the cache be cleared
        ajax = true;
        // eslint-disable-next-line no-param-reassign
        settings.clearCache = false;
      } else if (cacheLower < 0 || requestStart < cacheLower || requestEnd > cacheUpper) {
        // outside cached data - need to make a request
        ajax = true;
      } else if (JSON.stringify(request.order) !== JSON.stringify(cacheLastRequest.order) ||
        JSON.stringify(request.columns) !== JSON.stringify(cacheLastRequest.columns) ||
        JSON.stringify(request.search) !== JSON.stringify(cacheLastRequest.search)
      ) {
        // properties changed (ordering, columns, searching)
        ajax = true;
      }

      // Store the request for checking next time around
      cacheLastRequest = $.extend(true, {}, request);

      if (ajax) {
        // Need data from the server
        if (requestStart < cacheLower) {
          requestStart -= (requestLength * (conf.pages - 1));

          if (requestStart < 0) {
            requestStart = 0;
          }
        }

        cacheLower = requestStart;
        cacheUpper = requestStart + (requestLength * conf.pages);

        request.start = requestStart;
        request.length = requestLength * conf.pages;

        // Provide the same `data` options as DataTables.
        if ($.isFunction(conf.data)) {
          // As a function it is executed with the data object as an arg
          // for manipulation. If an object is returned, it is used as the
          // data object to submit
          const d = conf.data(request);
          if (d) {
            $.extend(request, d);
          }
        } else if ($.isPlainObject(conf.data)) {
          // As an object, the data given extends the default
          $.extend(request, conf.data);
        }
        // eslint-disable-next-line no-param-reassign
        settings.jqXHR = $.ajax({
          type: conf.method,
          url: conf.url,
          data: request,
          dataType: 'json',
          cache: conf.cache,
          success(json) {
            cacheLastJson = $.extend(true, {}, json);

            if (cacheLower !== drawStart) {
              json.data.splice(0, drawStart - cacheLower);
            }
            if (requestLength >= -1) {
              json.data.splice(requestLength, json.data.length);
            }

            drawCallback(json);
          },
        });
      } else {
        const json = $.extend(true, {}, cacheLastJson);
        json.draw = request.draw; // Update the echo for each response
        const { data } = json;
        if (data) {
          data.splice(0, requestStart - cacheLower);
          data.splice(requestLength, json.data.length);
        } else {
          json.data = [];
        }

        drawCallback(json);
      }
    };
  };
}

export function isProductionEnv() {
  return process.env.NODE_ENV === 'production';
}
